import { SnAlarm, SnAlarmMarker } from '@lib/api/entities';
import { COLORS } from '@lib/ui/theme';
import { GoogleMapMarker, GoogleMapMarkerType } from '@lib/geo/google/map';

export class AlarmMarker extends GoogleMapMarker {
  private _icons = {
    shotspotter: {
      fontIcon: 'Icon_ShotSpotter',
      fontSet: 'fs',
    },
    'shooter detection systems': {
      fontIcon: 'Icon_ShotSpotter',
      fontSet: 'fs',
    },
    'panic app': {
      fontIcon: 'Icon_Panic',
      fontSet: 'fs',
    },
    'rt alpr': {
      fontIcon: 'Icon_LPAR',
      fontSet: 'fs',
    },
    'vigilant learn alpr': {
      fontIcon: 'Icon_Vigilant',
      fontSet: 'fs',
    },
    'fs alpr': {
      fontIcon: 'Icon_FS',
      fontSet: 'fs',
    },
    'genetec alpr': {
      fontIcon: 'Icon_Genetec',
      fontSet: 'fs',
    },
    'rekor alpr': {
      fontIcon: 'Icon_Rekor',
      fontSet: 'fs',
    },
    DroneSense: {
      fontIcon: 'Icon_DroneSense',
      fontSet: 'fs',
    },
    SoundThinking: {
      fontIcon: 'Icon_ShotSpotter',
      fontSet: 'fs',
    },
  };

  private _styles = {
    'rt alpr': {
      scale: 1,
      strokeOpacity: 0,
      fillOpacity: 0,
    },
    'vigilant learn alpr': {
      scale: 1,
      stroke: 2.5,
      strokeOpacity: 1,
      fillOpacity: 0.5,
      fillColor: '#fff',
      strokeColor: COLORS['amber-300'],
    },
    'genetec alpr': {
      scale: 1,
      stroke: 2.5,
      strokeOpacity: 1,
      fillOpacity: 0.5,
      fillColor: '#fff',
      strokeColor: COLORS['amber-300'],
    },
    'fs alpr': {
      scale: 1,
      stroke: 2.5,
      strokeOpacity: 1,
      fillOpacity: 0.5,
      fillColor: '#fff',
      strokeColor: COLORS['amber-300'],
    },
    'rekor alpr': {
      scale: 1,
      stroke: 2.5,
      strokeOpacity: 1,
      fillOpacity: 0.5,
      fillColor: '#fff',
      strokeColor: COLORS['amber-300'],
    },
    DroneSense: {
      scale: 1,
      stroke: 2.5,
      strokeOpacity: 1,
      fillOpacity: 0.5,
      fillColor: '#fff',
      strokeColor: COLORS['amber-300'],
    },
  };

  constructor(public readonly alarm: SnAlarm, public typeAlarm?: SnAlarmMarker) {
    super({
      id: `alarm-${alarm.id}`,
      type: GoogleMapMarkerType.CIRCLE,
      lonLat: alarm.geometry.coordinates,
      icon: {
        fontSet: 'fs',
        fontIcon: 'Icon_GeneralAlert',
      },
      style: {
        scale: 1.2,
        strokeOpacity: 0,
        fillOpacity: 0,
      },
    });
    if (this._icons[alarm.type.toLowerCase()]) {
      this.setIcon(this._icons[alarm.type.toLowerCase()]);
    }
    if (this._styles[alarm.type.toLowerCase()]) {
      this.setStyle(this._styles[alarm.type.toLowerCase()]);
    }
  }
}
